import React from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router";
import { parseQuery, stringifyQuery } from "utilities";

// Higher Order Component parses url queryString and passes it down as parsed object
function withQueryParser(Component) {
  return withRouter(
    class Wrapper extends React.Component {
      static propTypes = {
        location: PropTypes.object.isRequired,
      };

      state = { query: {} };

      static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.location.search === prevState.query.$search) return null;
        return { query: Wrapper.getNewQuery(nextProps.location.search) };
      }
      static getNewQuery = (search: string): Object => {
        const query = parseQuery(search);

        /*eslint-disable*/
        // iterate over query keys and parse string-type-numbers to number-type-numbers
        Object.keys(query).forEach(key => {
          if (parseFloat(query[key]) == query[key]) {
            query[key] = parseFloat(query[key]);
          }
        });
        /*eslint-enable*/

        Object.defineProperties(query, {
          $search: {
            value: search,
            enumerable: false,
          },
          stringify: {
            value: params => stringifyQuery({ ...query, ...params }),
            enumerable: false,
          },
          overwrite: {
            value: obj => Wrapper.getNewQuery(stringifyQuery({ ...query, ...obj })),
            enumerable: false,
          },
        });
        return query;
      };

      render() {
        return <Component {...this.props} query={this.state.query} />;
      }
    }
  );
}

export default withQueryParser;



// WEBPACK FOOTER //
// ./src/components/HOC/withQueryParser.jsx